<ng-container *ngIf="!loading">
  <div class="flats-modal">

    <div class="flats-modal-body">

      <ng-container *ngIf="!otherRoomFlag">
        <div class="information">
          <ng-container *ngIf="!flat_modal_info">
            <div class="row">
              <div class="title">Себестоимость квартиры в тг.</div>
              <!-- <input class="form-control" type="number" [(ngModel)]="oneFlatDataSet1.priceAmount" placeholder="общая стоимость" (ngModelChange)="getNatNum('priceAmount')" onKeyPress="if(this.value.length==10) return false;"/> -->
              <span class="title"> {{this.oneFlatDataSet1.priceAmount | numberWithSpaces: 'twoDecimals'}} </span>
            </div>
            <div class="row">
              <div class="title">Себестоимость 1 кв.м. квартиры в тг.</div>
              <!-- <input class="form-control" type="number" [(ngModel)]="priceFlatPerSquare" placeholder="общая стоимость за м2" (ngModelChange)="getNatNum('priceFlatPerSquare')" onKeyPress="if(this.value.length==10) return false;"/> -->
              <span class="title">{{this.oneFlatDataSet3?.flatPlanAmount | numberWithSpaces}}</span>
            </div>
            <div class="row">
              <div class="title">Общая площадь № {{flat.flatNumber}} в кв.м.</div>
              <!-- <input class="form-control" type="number" [(ngModel)]="priceFlatPerSquare" placeholder="общая стоимость за м2" (ngModelChange)="getNatNum('priceFlatPerSquare')" onKeyPress="if(this.value.length==10) return false;"/> -->
              <span class="title">{{this.oneFlatDataSet1.flatArea | numberWithSpaces: 'twoDecimals'}} </span>
            </div>
            <div class="row">
              <div class="title">Полезная площадь в кв.м.</div>
              <span class="title">{{this.oneFlatDataSet1.usableArea | numberWithSpaces: 'twoDecimals'}} </span>
            </div>
            <div class="row">
              <div class="title">Площадь балкона/лоджии в кв.м.</div>
              <span class="title">{{this.oneFlatDataSet1.balconyArea | numberWithSpaces: 'twoDecimals'}} </span>
            </div>
            <div class="row">
              <div class="title">Подъезд</div>
              <span class="title">{{this.oneFlatDataSet1.entrance}} </span>
            </div>
            <div class="row">
              <div class="title">Дата реализации</div>
              <button class="btn-calendar" (click)="calendarModal = true">{{getDate(oneFlatDataSet1.saleDate)}}</button>
            </div>
            <div class="row">
              <div class="title">Стоимость реализации в тг. <br />
                за {{flat?.roomCountID}} ком. квартир № {{oneFlatDataSet1?.flatNumber?oneFlatDataSet1?.flatNumber:'-'}}
              </div>
              <input class="form-control" [mask]="'separator'"
                      type="text" [(ngModel)]="oneFlatDataSet1.saleAmount" *ngIf="saleAmount === true" placeholder="цена реализации" />
              <div class="real-cost" *ngIf="saleAmount === false">{{oneFlatDataSet1.saleAmount | numberWithSpaces}}</div>
              <span class="icon-edit" (click)="openEditor()"></span>
              <!-- <span ngif class="title">{{oneFlatDataSet1.saleAmount | numberWithSpaces}}</span> -->
            </div>
          </ng-container>

          <ng-container *ngIf="flat_modal_info">
            <div class="row">
              <div class="title">Номер квартиры</div>
              <input class="form-control" type="text" [(ngModel)]="oneFlatDataSet1.flatNumber" placeholder="номер квартиры" />
            </div>
            <div class="row">
              <div class="title">Общая площадь в кв.м.</div>
              <input class="form-control" type="number" [(ngModel)]="oneFlatDataSet1.flatArea" placeholder="общая площадь"
                (ngModelChange)="getNatNum('flatArea')" />
            </div>

            <div class="row">
              <div class="title">Подъезд</div>
              <input class="form-control" type="number" [(ngModel)]="oneFlatDataSet1.entrance" placeholder="подъезд"/>
            </div>

            <div class="row">
              <div class="title">Полезная площадь</div>
              <input class="form-control" type="number" [(ngModel)]="oneFlatDataSet1.usableArea" placeholder="полезная площадь"/>
            </div>

            <div class="row">
              <div class="title">Площадь балкона/лоджии</div>
              <input class="form-control" type="number" [(ngModel)]="oneFlatDataSet1.balconyArea" placeholder="площадь балкона/лоджии"/>
            </div>

            <div class="row">
              <div class="title">Угловая</div>
              <label class="checkbox">
                <input type="checkbox" [(ngModel)]="oneFlatDataSet1.isCornerFlat" />
              </label>
            </div>
            <div class="row">
              <div class="title">Отделка</div>
              <div class="radio-group">
                <input type="radio" id="option-one" name="selector" [checked]="!viewFurnishType" (click)="changeFurnishType(false)">
                <label for="option-one">Черновая</label>

                <input type="radio" id="option-two" name="selector" [checked]="viewFurnishType" (click)="changeFurnishType(true)">
                <label for="option-two">Чистовая</label>
              </div>
            </div>

            <div class="row furnishes" *ngIf="viewFurnishType">
              <div class="buttons">
                <div class="btn btn-apply" (click)="furnishModal = true">Тип отделки</div>
                <div class="btn" [ngClass]="furnishTemplate.length>0?'btn-apply': 'btn-cancel'" (click)="furnishTemplate.length>0?selectTemplate():''">Типовая</div>
              </div>
              <div class="textarea">
                <ng-container *ngFor="let type of oneFlatDataSet2">
                  <div class="li">
                    {{type?.furnishItemTitle}}
                    <span class="item-close" (click)="deleteFurnishType(type)"></span>
                  </div>
                </ng-container>
              </div>
            </div>

          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="otherRoomFlag">
        <div class="information">
          <div class="row">
            <div class="title">Количество {{placeType}}</div>
            <input class="form-control" type="number" [(ngModel)]="oneFlatDataSet1.placeCount" placeholder="Количество {{placeType}}" />
          </div>

          <div class="row">
            <div class="title">Общая площадь в кв.м.</div>
            <input class="form-control" type="number" [(ngModel)]="oneFlatDataSet1.area" placeholder="Общая площадь в кв.м." />
          </div>
        </div>
      </ng-container>

      <!-- <img *ngIf="imgHover" [src]="photoUrl" alt="Image"> -->

      <div class="img" [ngClass]="{'hover': imgHover}">
        <ng-container *ngIf="loadPlan">
          <img alt="" class="img-bg" [src]="imageUrl" (change)="handleFileInput($event)" *ngIf="oneFlatDataSet1.fileExtension !== 'pdf'">
          <pdf-viewer [src]="pdfSrc" [render-text]="true" [page]="page" [show-all]="true" style="display: flex;    width: 400px;
          height: 552px;"
            *ngIf="oneFlatDataSet1.fileExtension === 'pdf'"></pdf-viewer>
          <div class="zoom" (click)="zoomPhoto()" *ngIf="oneFlatDataSet1.fileExtension !== 'pdf'">
            <img alt="" class="zoom-img" src="./assets/svg-icons/zoom-photo.svg">
          </div>
        </ng-container>
        <div class="flats-modal-footer" *ngIf="!loadPlan">
          <ng-container>
            <!-- *ngIf="flat_modal_info" -->
            <div class="btn btn-apply-border">Загрузить план
              <input type="file" id="file" (change)="handleFileInput($event)">
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="spotForm === 'information'" class="incount">Введите количество квартир</div> -->
    <div class="flats-modal-footer">
      <!-- <ng-container *ngIf="flat_modal_info">
        <div class="btn btn-apply-border">Загрузить план
          <input type="file" id="file" (change)="handleFileInput($event.target.files)">
        </div>
      </ng-container>       -->
      <div class="btn btn-apply" (click)="confirm()">
        <ng-container *ngIf="!confirmLoader"> Подтвердить </ng-container>
        <ng-container *ngIf="confirmLoader">
          <div class="loading"></div>
        </ng-container>
      </div>
      <div class="btn btn-cancel" (click)="cancelModal()">Отменить</div>
      <div class="btn btn-apply" *ngIf="loadPlan && oneFlatDataSet1.photoFileID !== null &&  oneFlatDataSet1.photoFileID !== undefined" (click)="deletePlan(oneFlatDataSet1.photoFileID)">
        Удалить план
      </div>
    </div>


    <app-modal-window [title]="'Тип отделки'" *ngIf="furnishModal" [visible]="furnishModal" (close)="furnishModal = $event"
      [width]="650" [scrollbar]="false">
      <app-typeofot [flatID]="flatId" [furnishListEx]="oneFlatDataSet2" (selectedfurnishListEx)="getReturnFurnishes($event)"></app-typeofot>
    </app-modal-window>

  </div>
</ng-container>

<ng-container *ngIf="loading">
  <div class="loading"></div>
</ng-container>

<app-modal-window class="calendar-modal" [isCalendar]="true" *ngIf="calendarModal" [title]="'Календарь'" [visible]="calendarModal"
  (close)="calendarModal = $event" [width]="1300" [scrollbar]="false">
  <app-calendar [use]="'financing-flat'" [calendarType]="'setValueInDate'" [valueDimension]="''" [inputCompleteDate]="flatRealizationDateInfo"
    [editedDate]="editedDate" (outputCompleteDate)="completeFlatDateRealization($event); calendarModal = false"></app-calendar>
</app-modal-window>


<app-modal-window *ngIf="zoommedPhoto" [title]="'Фото плана'" [visible]="zoommedPhoto" (close)="zoommedPhoto = $event"
  [scrollbar]="false">
  <div class="zoommed-img">
    <img [src]="imageUrl" alt="">
  </div>
</app-modal-window>
